import type { ReactNode } from "react";
import { HolocronPageBackdrop } from "./HolocronPageBackdrop";
import { SmartLink } from "./SmartLink";

type HeroAction = {
  href: string;
  label: string;
  variant: "primary" | "secondary";
};

type PageHeroProps = {
  eyebrow: string;
  title: string;
  copy?: string;
  actions?: HeroAction[];
  children?: ReactNode;
};

export function PageHero({ eyebrow, title, copy, actions = [], children }: PageHeroProps) {
  return (
    <section className="page-hero">
      <HolocronPageBackdrop />
      <div className={`page-hero-content${children ? " has-aside" : ""}`}>
        <div className="page-hero-copy-block">
          <p className="page-eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          {copy ? <p className="page-hero-copy">{copy}</p> : null}
          {actions.length > 0 ? (
            <div className="hero-actions">
              {actions.map((action) => (
                <SmartLink
                  key={`${action.href}-${action.label}`}
                  className={`button ${action.variant}`}
                  href={action.href}
                >
                  {action.label}
                </SmartLink>
              ))}
            </div>
          ) : null}
        </div>

        {children ? <div className="page-hero-side">{children}</div> : null}
      </div>
    </section>
  );
}
